import React from "react";
import "./GalleriesFlat.scss";
import img1 from "../../assets/galleries/flat2/img1.png";
import img2 from "../../assets/galleries/flat2/img2.png";

function GalleryFlat2() {
  return (
    <section className="galleryFlat galleryFlat2">
      <div className="galleryFlat2__photos">
        <div className="galleryFlat2__photo galleryFlat2__photo--left">
          <img src={img1} alt="" className="galleryFlat__photo__img" />
        </div>
        <div className="galleryFlat2__photo">
          <img src={img2} alt="" className="galleryFlat__photo__img" />
        </div>
      </div>
      <p className="galleryFlat__copy galleryFlat2__copy">
        Roberto Coin admires the facade of the Loggia del Consiglio. The
        building, built in 1476, is a beautiful example of Verona’s unique
        Venetian Renaissance architecture.
      </p>
    </section>
  );
}

export default GalleryFlat2;
